<template>
  <div
    v-if="result"
    class="transaction-sheet-wrapper"
  >
    <div class="transaction-sheet-backdrop"></div>

    <section
      class="transaction-sheet"
      role="dialog"
      aria-modal="true"
    >
      <ModalCloseButton
        class="dialog-minimize-btn"
        @close="$emit('confirmAction')"
      />

      <div class="sheet-content">
        <h3 class="sheet-title">
          {{ $t('transaction_info.title') }}
        </h3>

        <TransactionSessionDetails
          :result="result"
          :show-transaction-rating="showTransactionRating"
        />

        <div class="action-row">
          <BButton
            class="next-btn"
            variant="primary"
            @click="$emit('confirmAction')"
          >
            {{ $t('transaction_info.close') }}
          </BButton>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import TransactionSessionDetails from '@/components/TransactionSessionDetails.vue'
  import ModalCloseButton from '@/components/ui/ModalCloseButton.vue'
  import { BButton } from 'bootstrap-vue-next'

  export default {
    name: 'TransactionDetail',
    components: {
      TransactionSessionDetails,
      BButton,
      ModalCloseButton
    },
    props: {
      result: {
        type: Object,
        default: null
      },
      showTransactionRating: {
        type: Boolean,
        default: false
      }
    },
    emits: ['confirmAction']
  }
</script>

<style scoped lang="scss">
  @use '@/main';

  .transaction-sheet-wrapper {
    position: fixed;
    inset: 0;
    z-index: 10000;
  }

  .transaction-sheet-backdrop {
    position: absolute;
    inset: 0;
    background: rgb(0 0 0 / 35%);
  }

  .transaction-sheet {
    position: absolute;
    left: 0;
    right: 0;
    bottom: var(--app-fixed-bottom-offset, 0px);
    background: #fff;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 -4px 20px rgb(0 0 0 / 15%);
    max-height: calc(var(--app-viewport-safe-height, 100vh) - 96px);
    max-height: calc(var(--app-viewport-safe-height, 100dvh) - 96px);
    overflow-y: auto;
  }

  .sheet-content {
    position: relative;
    padding: 24px;
    padding-top: 30px;
  }

  .sheet-title {
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    color: #303030;
    margin: 0 0 18px;
  }

  .dialog-minimize-btn {
    position: absolute;
    top: 18px;
    right: 14px;
    z-index: 2;
    border: none;
    background: transparent;
    color: #6c757d;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .action-row {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
  }

  .next-btn {
    min-width: 140px;
    font-weight: 700;
  }

  @media (max-width: 480px) {
    .sheet-content {
      padding: 16px;
      padding-top: 26px;
    }

    .sheet-title {
      font-size: 16px;
    }
  }
</style>
